module.exports = __webpack_public_path__ + "static/img/registro_abogado.747c59f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/registro_abogado.jpg
// module id = jX8T
// module chunks = 9